// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__bp4DY","uni":"style_uni__7Ja7I","card":"style_card__5I3nx"};